import { render, staticRenderFns } from "./sign-attribute-pane.vue?vue&type=template&id=685ff114&scoped=true&"
import script from "./sign-attribute-pane.vue?vue&type=script&lang=ts&"
export * from "./sign-attribute-pane.vue?vue&type=script&lang=ts&"
import style0 from "./sign-attribute-pane.vue?vue&type=style&index=0&id=685ff114&lang=scss&scoped=true&"
import style1 from "./sign-attribute-pane.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ff114",
  null
  
)

export default component.exports